import { createRequest } from "helpers/tools";

/**
 * @description Lead General Reports API helpers.
 * Backend contract: POST /api/lead/reports
 */

export type LeadReportGroupBy = "connection" | "aggregated";

export type LeadReportStatus =
    | "RECEIVED"
    | "PROCESSED"
    | "SENT"
    | "PROCESS_FAILED"
    | "SEND_FAILED"
    | "DUPLICATED"
    | "FAILED_TO_FETCH_DATA";

export interface LeadReportRequestBody {
    start_date: string; // YYYY-MM-DD
    end_date: string; // YYYY-MM-DD
    connection_ids?: number[];
    group_by: LeadReportGroupBy;
    statuses?: LeadReportStatus[];
}

export interface LeadReportSummary {
    total_leads: number;
    total_sent: number;
    total_failed: number;
    total_duplicated: number;
}

export interface LeadReportDailyBreakdown {
    date: string;
    sent: number;
    failed: number;
    total: number;
}

export interface LeadReportConnection {
    connection_id: number;
    connection_name: string;
    status: number;
    total_leads: number;
    sent_count: number;
    failed_count: number;
    duplicated_count: number;
    source_type: string;
    destination_type: string;
    daily_breakdown: LeadReportDailyBreakdown[];
}

export interface LeadReportSourceTypeItem {
    source_type: string;
    sent: number;
    failed: number;
    total: number;
}

export interface LeadReportResponseData {
    summary: LeadReportSummary;
    daily_breakdown: LeadReportDailyBreakdown[];
    connections?: LeadReportConnection[];
    source_type_breakdown?: LeadReportSourceTypeItem[];
}

export const getLeadGeneralReport = async (
    payload: LeadReportRequestBody,
) => {
    return await createRequest({
        suffix: "lead/reports",
        method: "post",
        handleError: false,
        payload,
    });
};
